export const SETATypes = 'SETATypes/';